import { create } from "zustand";

// Tracks background jobs (currently just document bulk imports) so a
// bottom-right tray can keep showing live progress after the dialog that
// started it is closed, or after navigating to a completely different
// page -- the same idea as Google Drive's own upload tray. This is
// intentionally not persisted across a full page reload: the job itself
// keeps running server-side either way (documentBulkImport.service.js's
// processInBackground doesn't care whether anyone is watching), a reload
// just means the tray has to be re-discovered -- see BackgroundJobsTray's
// own "recent jobs still processing" check on mount for that case.
export const useBackgroundJobsStore = create((set, get) => ({
  jobs: [], // [{ id, type: "DOCUMENT_BULK_IMPORT", label, dismissed }]

  addJob: (job) => {
    if (get().jobs.some((j) => j.id === job.id)) return;
    set((s) => ({ jobs: [...s.jobs, { ...job, dismissed: false }] }));
  },

  dismiss: (id) => set((s) => ({ jobs: s.jobs.map((j) => (j.id === id ? { ...j, dismissed: true } : j)) })),

  remove: (id) => set((s) => ({ jobs: s.jobs.filter((j) => j.id !== id) })),
}));
